import React from 'react' // eslint-disable-line no-unused-vars
import Select from '../../forms/Select'
import InputGroup from '../../forms/InputGroup'

import CountryAwareComponent from '../CountryAwareComponent'

// Notification Reference: https://github.com/LouisBarranqueiro/reapop#integration
// Extending Component Vs making a const: https://www.reddit.com/r/reactjs/comments/5dxpzx/extending_component_vs_making_a_const/
class RequestorInformation extends CountryAwareComponent {
  constructor (props) {
    super(props)

    this.titleOptions = [
      { value: 'Mr.', label: 'Mr.' },
      { value: 'Mrs.', label: 'Mrs.' },
      { value: 'Miss', label: 'Miss' },
      { value: 'Dr.', label: 'Dr.' },
      { value: 'Ms.', label: 'Ms.' },
      { value: 'Prof.', label: 'Prof.' },
      { value: 'Rev.', label: 'Rev.' }
    ]

    this.componentName = 'RequestorInformation'
    // this.medicalSpecialities = [{value:'speciality1', label:'speciality1'}];
    this.requestorTypes = []
    this.medicalSpecialities = []
    this.salutation = []

    this.countries = [
      {
        value: 'India',
        label: 'India',
        className: 'State-ACT'
      },
      {
        value: 'Cambodia',
        label: 'Cambodia',
        className: 'State-ACT'
      },
      {
        value: 'Nepal',
        label: 'Nepal',
        className: 'State-ACT'
      },
      {
        value: 'Pakistan',
        label: 'Pakistan',
        className: 'State-NSW'
      }
    ]
  }

  render () {
    this.medicalSpecialities = this.props.medicalSpecialities.map(({ speciality, translation }) => ({
      value: speciality,
      label: translation || speciality
    }))

    //  var uniquesalutation=[];
    //  this.props.salutation.map(function(item) {
    //       if (uniquesalutation.indexOf(item.salutation) === -1) {
    //           uniquesalutation.push(item.salutation);
    //     }
    // });
    this.salutation = this.props.salutation.map(item => ({
      value: item,
      label: item
    }))
    // this.requestorTypes = [{value: 'requestor1', label: 'requestor1'}];
    this.requestorTypes = this.props.requestorTypes.map(({ requestor, translation }) => ({
      value: requestor,
      label: translation || requestor
    }))
    // var countryOptions = this.countries;
    const jsx = (

      <div>
        <div className='row m-t-10'>
          {this.props.fields.title.display
            ? (
              <div className='col-lg-2 m-b-15'>
                <Select
                  searchable
                  clearable={false}
                  options={this.salutation}
                  field={this.props.fields.title}
                  validate={(e, field) => this.props.validate(e, this.props.fields.title)}
                />
              </div>)
            : null}

          {this.props.fields.firstname.display
            ? (
              <div className='col-lg-2 m-b-15'>
                <InputGroup
                  field={this.props.fields.firstname}
                  validate={(e, field) => this.props.validate(e, this.props.fields.firstname)}
                />
              </div>)
            : null}

          {this.props.fields.lastname.display
            ? (
              <div className='col-lg-2 m-b-15'>
                <InputGroup
                  field={this.props.fields.lastname}
                  validate={(e, field) => this.props.validate(e, this.props.fields.lastname)}
                />
              </div>)
            : null}

          {this.props.fields.email.display
            ? (
              <div className='col-lg-3 m-b-15'>
                <InputGroup
                  field={this.props.fields.email}
                  validate={(e, field) => this.props.validate(e, this.props.fields.email)}
                  maxLength={50}
                />
              </div>)
            : null}

          {this.props.fields.phone.display
            ? (
              <div className='col-lg-2 m-b-15'>
                <InputGroup
                  field={this.props.fields.phone}
                  validate={(e, field) => this.props.validate(e, this.props.fields.phone)}
                />
              </div>)
            : null}

          {this.props.fields.extn.display
            ? (
              <div className='col-lg-1 m-b-15'>
                <InputGroup
                  field={this.props.fields.extn}
                  validate={(e, field) => this.props.validate(e, this.props.fields.extn)}
                />
              </div>)
            : null}
        </div>
        <div className='row'>
          {this.props.fields.userType.display
            ? (
              <div className='col-lg-3 m-b-15'>
                <Select
                  searchable
                  clearable={false}
                  options={this.requestorTypes}
                  field={this.props.fields.userType}
                  validate={(e, field) => this.props.validate(e, this.props.fields.userType)}
                />
              </div>)
            : null}

          {this.props.fields.medicalSpeciality.display
            ? (
              <div className='col-lg-3 m-b-15'>
                <Select
                  searchable
                  clearable={false}
                  options={this.medicalSpecialities}
                  field={this.props.fields.medicalSpeciality}
                  validate={(e, field) => this.props.validate(e, this.props.fields.medicalSpeciality)}
                />
              </div>)
            : null}

          {this.props.fields.affiliation.display
            ? (
              <div className='col-lg-3 m-b-15'>
                <InputGroup
                  field={this.props.fields.affiliation}
                  validate={(e, field) => this.props.validate(e, this.props.fields.affiliation)}
                />
              </div>)
            : null}
          {this.props.fields.hcpLicenseNumber.display
            ? (
              <div className='col-lg-3 m-b-15'>
                <div id='hcpLicenseNumber'>
                  <InputGroup
                    field={this.props.fields.hcpLicenseNumber}
                    validate={(e, field) => this.props.validate(e, this.props.fields.hcpLicenseNumber)}
                  />
                </div>
              </div>)
            : null}
        </div>

        <div className='row'>
          {this.props.fields.street.display
            ? (
              <div className='col-lg-3 m-b-15'>
                <InputGroup
                  field={this.props.fields.street}
                  validate={(e, field) => this.props.validate(e, this.props.fields.street)}
                />
              </div>)
            : null}
          {this.props.fields.city.display
            ? (
              <div className='col-lg-3 m-b-15'>
                <InputGroup
                  field={this.props.fields.city}
                  validate={(e, field) => this.props.validate(e, this.props.fields.city)}
                />
              </div>)
            : null}
          {this.props.fields.state.display
            ? (
              <div className='col-lg-3 m-b-15'>
                <InputGroup
                  field={this.props.fields.state}
                  validate={(e, field) => this.props.validate(e, this.props.fields.state)}
                />
              </div>)
            : null}

          {this.props.fields.postalCode.display
            ? (
              <div className='col-lg-3 m-b-15'>
                <InputGroup
                  field={this.props.fields.postalCode}
                  validate={(e, field) => this.props.validate(e, this.props.fields.postalCode)}
                  maxLength={20}
                />
              </div>)
            : null}
        </div>
      </div>
    )
    return this.countriesMatched() ? jsx : null
  }
}

export default RequestorInformation



// WEBPACK FOOTER //
// ./src/mi-app/submitInquiry/RequestorInformation.js